import type { ContentType } from "@brookbush/database";
import type { LinkedProgramPreview } from "@brookbush/types";

import useSWRImmutable from "swr/immutable";

const useLinkedProgram = (contentId: string, contentType: ContentType) => {
	const { data: program, isLoading } =
		useSWRImmutable<LinkedProgramPreview | null>(
			`/programs/preview?contentId=${contentId}&contentType=${contentType}`,
		);

	return { program: program ?? null, isLoading };
};

export default useLinkedProgram;
